var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudiooff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Disable_audio_notification",
    "data-name": "Disable audio notification",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.8,
    height: 22.8,
    viewBox: "0 0 18.8 22.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "block-microphone",
    d: "M16.6,2a4.565,4.565,0,0,0-4.557,4.56v7.6a4.567,4.567,0,0,0,3.549,4.448,6.374,6.374,0,0,1,.055-.775c.029-.216.073-.427.122-.635a6.587,6.587,0,0,1,3.93-4.58,6.365,6.365,0,0,1,.617-.216c.027-.008.054-.018.081-.026a6.936,6.936,0,0,1,.76-.167V6.56A4.565,4.565,0,0,0,16.6,2Zm0,16.72Z",
    transform: "translate(-9 -2)",
    fill: "#c6d6ed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "block-microphone-2",
    "data-name": "block-microphone",
    d: "M22.906,14.226a5.57,5.57,0,1,0,5.57,5.57A5.576,5.576,0,0,0,22.906,14.226Zm0,1.519a4.024,4.024,0,0,1,2.275.7L19.557,22.07a4.023,4.023,0,0,1-.7-2.274,4.047,4.047,0,0,1,4.051-4.051Zm3.349,1.776a4.047,4.047,0,0,1-5.623,5.623Z",
    transform: "translate(-9.676 -3.072)",
    fill: "#8ba5c9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "block-microphone-3",
    "data-name": "block-microphone",
    d: "M9.76,11.627a.759.759,0,0,0-.76.76V14.16a7.606,7.606,0,0,0,6.836,7.559V24.04a.76.76,0,1,0,1.519,0v-.826a6.728,6.728,0,0,1-1.032-1.459c-.086-.167-.166-.337-.238-.51s-.137-.35-.193-.529-.106-.354-.146-.536a6.084,6.084,0,0,1-5.226-6.02V12.387A.759.759,0,0,0,9.76,11.627ZM16.6,18.72Z",
    transform: "translate(-9 -2)",
    fill: "#bccde3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiooff);
export default __webpack_public_path__ + "static/media/audio off.ad928d59.svg";
export { ForwardRef as ReactComponent };